import React, { useEffect, useState } from "react";
import { FxmsData } from "../../fxms/datas/FxData";
import { FxWindow } from "./../../fxms/windows/FxWindows";
import {
  columns2_3,
} from "../ui/helper/UI_2_3.helper";
import {
  getYesterday,
  getMonthBetween,
  getInloInfo,
  getYesterDayOfMonth,
  exportRowsToExcel
} from "../common/commonMethod";
import {
  DataGrid,
  GridToolbarContainer,
} from "@mui/x-data-grid";
import { Box, Button } from "@mui/material";
import UI2ColumnChart from "./helper/UI2ColumnChart";
import FileDownloadIcon from "@mui/icons-material/FileDownload";


/**
 * 운전현황 > 공용설비 운영현황
 * 개발자 : 손지은
 * 개발년월 : 2024.10
 * @param {*} props
 * @returns
 */

export const UI_2_3 = (props) => {
  const yesterday = getYesterday();
  const yesterDayOfMonth = getYesterDayOfMonth();
  const user = FxmsData.getUser();
  const inlo = getInloInfo(FxmsData.getInlo(user.inloNo), user);
  const [rows, setRows] = React.useState([]);
  const [data, setData] = React.useState([]);
  const [columns, setColumns] = useState(columns2_3);
  const [startDate, setStartDate] = useState(yesterDayOfMonth);
  const [endDate, setEndDate] = useState(yesterday);
  const [pageSize, setPageSize] = useState(25);
  const [titleEng, setTitleEng] = useState("");
  const [titleMethod, setTitleMethod] = useState("");
  const handlePageSizeChange = (newPageSize) => {
    setPageSize(newPageSize);
  };
  const [selected, setSelected] = useState({
    method: "cons",
    complexInloNo: user.ugrpNo === 1021||user.ugrpNo === 1024? inlo.complexInloNo : "",
    companyInloNo:user.ugrpNo === 1024? inlo.companyInloNo : "",
    plantInloNo: user.ugrpNo === 1024? inlo.inloNo : "",
    engId: "EPWR",
    facNo: "",
    facName: "",
    startDate: "",
    endDate: ""
  });
  const [fetchEnergyOption, setFetchEnergyOption] = useState([]);
  const [fetchComplexInlo, setFetchComplexInlo] = useState([]);
  const [fetchCompanyInlo, setFetchCompanyInlo] = useState([]);
  const [fetchPlantInlo, setFetchPlantInlo] = useState([]);
  const [fetchFacNo, setFetchFacNo] = useState([]);

  const energyConsOption = [
    { label: "전기", value: "EPWR" },//!!  value 확인필요
    { label: "가스", value: "GAS" }
  ];

  const energyProdOption = [

    { label: "압축공기", value: "AIR" },
    { label: "스팀", value: "STEAM" }
  ];

  const submitBtnClick = async () => {
    if (selected == null) return;

    if (parseInt(selected.startDate) > parseInt(selected.endDate)) {
      FxWindow.alert("조회 기간이 잘못되었습니다.", true);
      return;
    } else if (
      getMonthBetween(selected.startDate.replace(/-/gi, ""), selected.endDate.replace(/-/gi, "")) > 5*12
    ) {
      FxWindow.alert("최대 5년까지 조회 가능합니다.", true);
      return;
    }


    const param = {
      method: selected.method,
      engId: selected.engId,
      complexInloNo: selected.complexInloNo,
      companyInloNo: selected.companyInloNo,
      plantInloNo: selected.plantInloNo,
      facNo: selected.facNo,
      facName: selected.facName,
      startDate: startDate.replace(/-/gi, ""),
      endDate: endDate.replace(/-/gi, ""),
      gubun: 'day',
    }
    try {
      const uri = "vup/select_2_3";
      const res = await FxmsData.selectGridData(uri, param);
      console.log("UI_2_3 res........", res.data);

      let index = 0;
      for (let data of res.data) {
        data.id = index++;
      }
      FxWindow.alert(res.data.length + " 건의 데이터가 조회되었습니다.");

      setData(res.data);

      
      
      let title = selected.engId==="AIR" && selected.method=="prod" || selected.engId==="EPWR" && selected.method=="cons"? "공용공압기":"공용보일러"

      if(selected.engId==="AIR") setTitleEng(title + " 압공 ");
      else if(selected.method==="prod"  && selected.engId==="STEAM") setTitleEng(title + " 스팀 ");
      else if(selected.engId==="EPWR")  setTitleEng(title + " 전력 "); 
      else if(selected.method=="cons" && selected.engId==="GAS") setTitleEng(title + " 가스 "); 
         
      setTitleMethod(selected.method==="cons"? "사용량 집계":"공급량 집계");
    

      let response = res.data;
      response.map((item, index) => {
        return { ...item, id: index };
      });

      // 그리드에 데이터
      setRows(response);
      //  제외할 키 목록
      const excludedKeys = new Set([
        "psDate",
        "method",
        "engName",
        "engId",
        "engUnit",
        "inloNo",
        "complexInloName",
        "companyInloName",
        "plantInloName",
        "facNo", //삭제예정
        "facName",
        "epwrAmt",
        "sumAmt",
        "id",
      ]);

     

      let result = response.flatMap((obj) => {
        // 필터링된 키들을 담을 배열
        const filteredKeys = [];
        
        // 기존 객체의 모든 키를 순회합니다.
        for (let key in obj) {
          // 제외할 키가 아니라면 배열에 추가합니다.
          if (!excludedKeys.has(key)) {
            filteredKeys.push({
              field: key,
              headerName: key,
              width: 120,              
              headerClassName: "DataGridHeader",
              valueFormatter: (params) => {
                // return new Intl.NumberFormat("ko-KR").format(params.value);
                return new Intl.NumberFormat("ko-KR").format(Math.round(params.value));
              },
            });
            
          }
        }

        //키 정렬렬
        filteredKeys.sort((a, b) => a.field > b.field ? 1 : -1);
        return filteredKeys;
      });
      // 중복 제거
      result = Array.from(
        new Map(result.map((item) => [item.field, item])).values()
      );
      setColumns((prev) => [...columns2_3, ...result]);

      console.log("columns2_3........", columns2_3);

    } catch (e) {
      console.log("UI_6_2 fetchData error", e);
    }
  }

  useEffect(() => {
    console.log("*** UI_2_3 ***");
  
    // 에너지 옵션은 항상 설정
    setFetchEnergyOption(energyConsOption); 
    // selectedPlant(inlo.inloNo); // 이 줄 제거

    const initializeData = async () => {
      if(user.ugrpNo !== 1021 && user.ugrpNo !== 1024){ // 산단      
        const uri = "vup/getComplexInloList";
        try {
          const res = await FxmsData.GET(uri);
          
          const complexlist = res.data.filter(x => (x.inloName === "시화도금단지" || x.inloName === "인천표면처리센타"));
          setFetchComplexInlo(complexlist);
          
          if (complexlist.length > 0) {
            // selected 상태 업데이트
            setSelected(prev => ({ 
              ...prev, 
              complexInloNo: complexlist[0]?.inloNo 
            }));
            selectedComplex(complexlist[0]?.inloNo );
          }
        } catch (e) {
          console.log("getComplexInloList error ........", e);
        }
      } else {
        submitBtnClick();
      }
    };

    initializeData();
  }, [inlo, user]);

  // fetchComplexInlo가 업데이트된 후 조회하는 useEffect 추가
  useEffect(() => {
    if (fetchComplexInlo.length > 0 && user.ugrpNo === 1020) {
      // selected 상태가 업데이트된 후 조회
      setTimeout(() => {
        submitBtnClick();
      }, 100);
    }
  }, [fetchComplexInlo]);

    useEffect(()=>{
      if (inlo.complexInloNo && user.ugrpNo !== 1024) {
        selectedComplex(inlo.complexInloNo);
      }
    },[selected.method, selected.engId]);

    

  const getComplexInloData = async () => {
    const uri = "vup/getComplexInloList"
    try {
      const res = await FxmsData.GET(uri);

      const complexlist = res.data.filter(x => (x.inloName === "시화도금단지" || x.inloName === "인천표면처리센타"));

      setFetchComplexInlo(complexlist);
      console.log("complex List >> ", complexlist);
    } catch (e) {
      console.log("getComplexInloList error ........", e);
    }
  }

  // engId가 변경될 때 설비 목록 다시 로드
  useEffect(() => {
    if (selected.engId && selected.plantInloNo) {
      selectedPlantWithEngId(selected.plantInloNo, selected.engId);
    }
  }, [selected.engId, selected.plantInloNo]);

  const selectedMethod = async (value) => {
    setSelected((prev) => ({ ...prev, method: value }));
    if (value === "cons") {
      setFetchEnergyOption(energyConsOption);
      setSelected((prev) => ({ ...prev, engId: "EPWR" }));
    } else {
      setFetchEnergyOption(energyProdOption);
      setSelected((prev) => ({ ...prev, engId: "AIR" }));
    }
  }

  const selectedComplex = async (value) => {
    console.log("선택된 산단번호 ::", value);
    setSelected((prev) => ({ ...prev, complexInloNo: value }));

    console.log("selected ........", selected);

    if (value === "") {
      setFetchCompanyInlo([]);
      setSelected((prev) => ({ ...prev, companyInloNo: value }));
      setSelected((prev) => ({ ...prev, plantInloNo: value }));
      setSelected((prev) => ({ ...prev, facNo: value }));
    } else {
      const uri = "vup/getCompanyInloList/" + value;
      try {
        const res = await FxmsData.GET(uri);

        const companyList = res.data.filter(x => (x.inloName === "조합공용"));
        setFetchCompanyInlo(companyList);
        console.log("company List >>", res.data);
      } catch (e) {
        console.log("getCompanyInloList error.... ", e);
      }
    }
    setFetchPlantInlo([]); // 산단을 변경하면 plantInlo를 초기화
    setFetchFacNo([]);

    console.log("selected ........", selected);
  }

  const selectedCompany = async (value) => {
    console.log("선택된 회사번호 :: ", value);
    setSelected((prev) => ({ ...prev, companyInloNo: value }));

    if (value === "") {
      setFetchPlantInlo([]);
      setSelected((prev) => ({ ...prev, plantInloNo: value }));
      setSelected((prev) => ({ ...prev, facNo: value }));
    } else {
      const uri = "vup/getPlantInloList/" + value;
      try {
        const res = await FxmsData.GET(uri);
        setFetchPlantInlo(res.data);

        console.log("plant List >>", res.data);
      } catch (e) {
        console.log("getPlantInloList error.... ", e);
      }
    }
    setFetchFacNo([]);
  }

  const selectedPlant = async (value) => {
    console.log("선택된 공장번호 ::", value);
    setSelected((prev) => ({ ...prev, plantInloNo: value }));
    if (value === "") {
      setSelected((prev) => ({ ...prev, facNo: value }));
      setFetchFacNo([]);
      return;
    } else {
      const uri = "vup/getFacNoList/" + value;
      try {

        var engId = selected.engId == "EPWR" ? "AIR" :
                    selected.engId == "GAS" ? "STEAM" :
                    selected.engId;
        const res = await FxmsData.GET(uri, {
          engId: engId,
        });

        setFetchFacNo(res.data);
        console.log("fac List >> ", fetchFacNo);
      } catch (e) {
        console.log("getFacNoList error ........", e);
      }
    }
  }

  const selectedFac = (event) => {
    setSelected((prev) => ({ ...prev, facNo: event.target.value }));
    setSelected((prev) => ({ ...prev, facName: event.target.options[event.target.selectedIndex].text }));
  }


  const onChangeDatas = (event) => {
    const { id, value, name } = event.target;

    if (event.target.name == 'startDate') {
      setStartDate(value);
    }
    if (event.target.name == 'endDate') {
      setEndDate(value);
    }

    setSelected((prev) => {
      return { ...prev, [name]: value };
    })
  }

  // 새로운 함수 추가
  const selectedPlantWithEngId = async (plantInloNo, engId) => {
    
    if (plantInloNo === "") {
      setFetchFacNo([]);
      return;
    } else {
      const uri = "vup/getFacNoList/" + plantInloNo;
      var searchEngId = selected.engId == "EPWR" ? "AIR" :
                        selected.engId == "GAS" ? "STEAM" :
                        selected.engId;
      
      try {
        const res = await FxmsData.GET(uri, {
          engId: searchEngId,  // 전달받은 engId 사용
        });

        setFetchFacNo(res.data);
        console.log("fac List >> ", res.data);
      } catch (e) {
        console.log("getFacNoList error ........", e);
      }
    }
  }

  const CustomToolbar = () => {
    return (
      <GridToolbarContainer sx={{ float: "right" }} />
    );
  };


  const exportToExcel = () => {
    exportRowsToExcel({
      columns,
      rows,
      fileName: props.menuFullName || "tableData",
      sheetName: (props.menuFullName || "downloadData").replaceAll("/", "_"),
      excludeId: true
    });
  };

  return (
    <>
      <div className="FxCrudFilter">
        <div className="FxFilterLeft">
          <label className="FxLabelSearch"></label>
          <select className="FxSelectSearch" name="method" onChange={(e) => selectedMethod(e.target.value)}>
            <option value="cons" name="method">사용</option>
            <option value="prod" name="method">공급</option>          
            </select>
            <select className="FxSelectSearch" name="engId" value={selected.engId} onChange={onChangeDatas}>
            {fetchEnergyOption.map((item, index) => (
              <option key={index} value={item.value} name="engId">
                {item.label}
              </option>
            ))}
          </select>  

          <label className="FxLabelSearch"></label>
          {user.ugrpNo === 1021 || user.ugrpNo === 1024 ?
            <select className="FxSelectSearch" value={inlo.complexInloNo}>
              <option value={inlo.complexInloNo}> {inlo.complexInloName} </option>
            </select>
            :
            <select className="FxSelectSearch" onChange={(e) => selectedComplex(e.target.value)}>
              {/* <option value="">산업단지 전체</option> */}
              {fetchComplexInlo.map((item) => (
                <option key={item.inloNo} value={item.inloNo} name="complexInloNo">
                  {item.inloName}
                </option>
              ))}
            </select>
          }
          <label className="FxLabelSearch"></label>
          {user.ugrpNo === 1024 ?
            <select className="FxSelectSearch" value={inlo.companyInloNo}>
              <option value={inlo.companyInloNo}> {inlo.companyInloName} </option>
            </select>
            :
            <select className="FxSelectSearch" onChange={(e) => selectedCompany(e.target.value)}>
              <option value="">회사 전체</option>
              {fetchCompanyInlo.map((item) => (
                <option key={item.inloNo} value={item.inloNo} name="companyInloNo">
                  {item.inloName}
                </option>
              ))}
            </select>}

          <label className="FxLabelSearch"></label>
          {user.ugrpNo === 1024 ?
            <select className="FxSelectSearch" value={user.inloNo}>
              <option value={user.inloNo}> {user.inloName} </option>
            </select>
            :
            <select className="FxSelectSearch" onChange={(e) => selectedPlant(e.target.value)}>
              <option value="">사업장 전체</option>
              {fetchPlantInlo?.map((item) => (
                <option key={item.inloNo} value={item.inloNo} name="plantInloNo">
                  {item.inloName}
                </option>
              ))}
            </select>
          }
          <label className="FxLabelSearch"></label>
          <select className="FxSelectSearch" name="facNoSearch" onChange={(e) => selectedFac(e)}>
            <option value="">설비 전체</option>
            {fetchFacNo.map((item) => (
              <option key={item.facNo} value={item.facNo} name="facNo">
                {item.facName}
              </option>
            ))}
          </select>
        </div>
        <div className="FxFilterRight">
          <input className="FxDate" type="date" name="startDate" value={startDate} onChange={onChangeDatas} />
          <label className="FxLabelSearch">~</label>
          <input className="FxDate" type="date" name="endDate" value={endDate} onChange={onChangeDatas} />
          <input className="FxButtonSearch" type="button" value="조회" onClick={submitBtnClick} />
        </div>
      </div>
      <div style={{ height: "440px" }}>
        <UI2ColumnChart dataList={data} title={titleEng+titleMethod} type={"DAY"} />
      </div>
      <div className="FxCrudDataGrid">
        <div className="excelDown">
          <Button onClick={exportToExcel} startIcon={<FileDownloadIcon />}>
            엑셀 다운로드
          </Button>
        </div>
        <Box className="DataGridList" sx={{ height: "430px", width: "100%" }}>
          <DataGrid
            className="DataGrid"
            cellClassName="DataGridCell"
            rowHeight={36}
            rows={rows}
            columns={columns}
            components={{ Toolbar: CustomToolbar }}
            pageSize={pageSize}
            onPageSizeChange={handlePageSizeChange}
            rowsPerPageOptions={[25, 50, 100]}
          ></DataGrid>
        </Box>
      </div>
      <footer>
        <div>Virtual Utility Plant</div>
        <div>Copyright 2022 VUP All rights reserved</div>
      </footer>
    </>
  );
};
